import { render, staticRenderFns } from "./SignInIcon.vue?vue&type=template&id=123130df&"
import script from "./SignInIcon.vue?vue&type=script&lang=js&"
export * from "./SignInIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports